<template>
  <section class="py-5 bg-white">
    <div class="container">
      <h2 class="text-center fw-bold mb-2 section-title">
        Simplifica tu Práctica Médica con Medicynia
      </h2>
      <div class="text-center mb-5">
        <span class="section-underline"></span>
      </div>
      <p class="text-center text-muted mb-5 fs-5">
        Enfócate en tus pacientes, nosotros nos encargamos de la tecnología y el cumplimiento normativo.
      </p>
      <div class="row justify-content-center g-4">
        <div class="col-md-6 col-lg-3 text-center">
          <div class="mb-3">
            <i class="bi bi-shield-fill-check fs-1" style="color: #02eebe;"></i>
          </div>
          <h5 class="fw-bold mb-2">Cumplimiento NOM-004</h5>
          <p class="text-muted">Genera notas y expedientes que cumplen con los lineamientos oficiales de México.</p>
        </div>
        <div class="col-md-6 col-lg-3 text-center">
          <div class="mb-3">
            <i class="bi bi-stopwatch-fill fs-1" style="color: #02eebe;"></i>
          </div>
          <h5 class="fw-bold mb-2">Eficiencia y Ahorro de Tiempo</h5>
          <p class="text-muted">Agenda citas, registra consultas y emite recetas en minutos, no horas.</p>
        </div>
        <div class="col-md-6 col-lg-3 text-center">
          <div class="mb-3">
            <i class="bi bi-lock-fill fs-1" style="color: #02eebe;"></i>
          </div>
          <h5 class="fw-bold mb-2">Máxima Seguridad de Datos</h5>
          <p class="text-muted">Información encriptada, respaldos diarios y acceso seguro a tus expedientes.</p>
        </div>
        <div class="col-md-6 col-lg-3 text-center">
          <div class="mb-3">
            <i class="bi bi-phone-fill fs-1" style="color: #02eebe;"></i>
          </div>
          <h5 class="fw-bold mb-2">Accesible Donde Quieras</h5>
          <p class="text-muted">Sistema responsivo para acceder desde tu computadora, tablet o smartphone.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BenefitsSection'
}
</script>

<style scoped>
.section-title {
  font-size: 2.5rem;
}
.section-underline {
  display: inline-block;
  width: 70px;
  height: 4px;
  background: #02eebe;
  border-radius: 2px;
  margin-bottom: 0.5rem;
}
</style>
